/**
 * Normalizes an i18next language code (e.g. `en-US`, `fr`) down to one of the
 * three languages this app ships translations for, defaulting to French.
 *
 * Several call sites already carry a locally duplicated copy of this helper
 * (`about/page.tsx`, `Navbar.tsx`, `ThemeProvider.tsx`, `useCurrentTheme.ts`).
 * This shared version is for new code only — existing usages are left as-is
 * to keep this change's footprint minimal.
 */

export const SUPPORTED_LANG_CODES = ['fr', 'en', 'es'] as const

export type SupportedLangCode = (typeof SUPPORTED_LANG_CODES)[number]

export function resolveLanguage(inputLang: string): SupportedLangCode {
  const code = inputLang.substring(0, 2).toLowerCase()
  const match = SUPPORTED_LANG_CODES.find((supported) => supported === code)
  return match ?? 'fr'
}

/** The content language the backend assumes when an investigation is created
 * without an explicit `sourceLocale`. */
export const DEFAULT_CONTENT_LOCALE: SupportedLangCode = 'fr'
